import {useRouteError} from 'react-router';

import {Text} from 'components/Text/Text';

type RouterErrorObject = {
    statusText?: string;
    message?: string;
};

export const ErrorRoute: React.FC = () => {
    const error = useRouteError() as RouterErrorObject;

    return (
        <div id="error-page">
            <Text.Bold24>Что-то пошло не так!</Text.Bold24>
            <br />
            <Text.Regular14>{error.statusText || error.message}</Text.Regular14>
        </div>
    );
};
